
















































































import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
// import { ipcRenderer } from 'electron'

@Component
export default class About extends Vue {
  @Getter('currentTheme') private getterTheme!: Theme
  @Getter('currentLang') private getterLang!: Language

  get logo(): string {
    if (this.getterTheme === 'light') {
      return require('../../assets/images/logo.svg')
    }
    return require('../../assets/images/logo.svg')
  }

  get emqxWebsite(): string {
    return this.getterLang === 'zh' ? 'https://www.emqx.cn/' : 'https://www.emqx.io/'
  }

  private checkUpdate(): void {
    // ipcRenderer.send('checkUpdate')
  }

  private goToLink(url: string) {
    const windowUrl = window.open(url)
    if (windowUrl) {
      windowUrl.opener = null
    }
  }
}
